import http from 'plugins/axios';

export default {
  enums() {
    return http.get({ url: '/ta/admin/tenant/vip/level/enums' });
  },
  next() {
    return http.get({ url: '/ta/admin/tenant/vip/level/next' });
  },
  page({ page, size }) {
    return http.get({ url: `/ta/admin/tenant/vip/level/page?page=${page}&size=${size}` });
  },
  detail(id) {
    return http.get({ url: `/ta/admin/tenant/vip/level/detail?id=${encodeURIComponent(id)}` });
  },
  thresholdConfig() {
    return http.get({ url: '/ta/admin/tenant/vip/level/threshold-config' });
  },
  saveThresholdConfig(data) {
    return http.post({ url: '/ta/admin/tenant/vip/level/threshold-config', data });
  },
  save(data) {
    return http.post({ url: '/ta/admin/tenant/vip/level/save', data });
  },
  update(data) {
    return http.post({ url: '/ta/admin/tenant/vip/level/update', data });
  },
  delete(id) {
    return http.post({ url: `/ta/admin/tenant/vip/level/delete?id=${encodeURIComponent(id)}` });
  },
};
